var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _g2, _path8, _g3, _path9, _g4, _path0, _g5, _path1, _g6, _path10, _g7, _path11, _g8, _path12, _g9, _path13, _g0, _path14, _g1, _path15, _g10, _path16, _g11, _path17, _g12, _path18, _g13, _path19, _g14, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g15, _path27, _g16, _path28, _g17, _path29, _g18, _path30, _g19, _path31, _g20, _path32, _g21, _path33, _g22, _path34, _path35, _path36, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLaptopTick = function SvgLaptopTick(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_411_152)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 160C124.183 160 160 124.183 160 80C160 35.8172 124.183 0 80 0C35.8172 0 0 35.8172 0 80C0 124.183 35.8172 160 80 160Z",
    fill: "#F6F0DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.466 24.668C49.658 25.193 49.121 26.1 49.121 27.135V76.168C49.429 76.541 49.722 76.965 49.988 77.426V26.268C49.989 25.677 50.167 25.129 50.466 24.668Z",
    fill: "#EDE1B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.936 106.141C77.756 106.407 77.547 106.694 77.299 107.008H107.58C108.615 107.008 109.522 106.471 110.047 105.663C109.586 105.963 109.038 106.141 108.447 106.141H77.936Z",
    fill: "#EDE1B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.375 28.8913C87.375 29.5533 86.838 30.0903 86.176 30.0903H75.342C74.604 30.0903 74.006 29.4923 74.006 28.7543V27.2363H53.901V102.228H107.478V27.2363H87.375V28.8913Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.783 34.9339L66.308 36.1439H65.259L65.783 34.9339ZM65.553 34.2109L64.127 37.4779H64.684L65.052 36.6219H66.515L66.888 37.4779H67.449L66.023 34.2109H65.553Z",
    fill: "#260046"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_411_152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 32,
    width: 33,
    height: 7
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.714 32.2051H64.127V38.4911H96.714V32.2051Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_411_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.585 37.4778H69.079V37.2388C68.927 37.4318 68.674 37.5238 68.444 37.5238C67.901 37.5238 67.551 37.1468 67.551 36.5528V35.1768H68.057V36.4698C68.057 36.8328 68.236 37.0628 68.554 37.0628C68.789 37.0628 68.982 36.9158 69.079 36.6998V35.1768H69.585V37.4778Z",
    fill: "#260046"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_411_152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 32,
    width: 33,
    height: 7
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.714 32.2051H64.127V38.4911H96.714V32.2051Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_411_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.834 35.1773H74.34V35.4853C74.427 35.3103 74.662 35.1543 74.92 35.1543C75.017 35.1543 75.099 35.1683 75.155 35.1823L75.081 35.6743C75.035 35.6563 74.961 35.6463 74.883 35.6463C74.681 35.6463 74.441 35.7613 74.34 36.0003V37.4773H73.834V35.1773Z",
    fill: "#260046"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_411_152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 32,
    width: 33,
    height: 7
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.714 32.2051H64.127V38.4911H96.714V32.2051Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_411_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.322 37.5238C75.641 37.5238 75.176 36.9768 75.176 36.3278C75.176 35.6788 75.641 35.1318 76.322 35.1318C76.593 35.1318 76.833 35.2238 76.994 35.3898V35.1778H77.5V37.4788H76.994V37.2628C76.833 37.4318 76.593 37.5238 76.322 37.5238ZM76.382 37.0638C76.677 37.0638 76.874 36.9258 76.994 36.7418V35.9088C76.874 35.7298 76.676 35.5908 76.382 35.5908C75.977 35.5908 75.697 35.9218 75.697 36.3268C75.696 36.7328 75.977 37.0638 76.382 37.0638Z",
    fill: "#260046"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_411_152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 32,
    width: 33,
    height: 7
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.714 32.2051H64.127V38.4911H96.714V32.2051Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_411_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.958 34.3065L78.464 33.8125V37.4785H77.958V34.3065Z",
    fill: "#260046"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_411_152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 32,
    width: 33,
    height: 7
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M96.714 32.2051H64.127V38.4911H96.714V32.2051Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_411_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.175 34.8323C78.991 34.8323 78.839 34.6803 78.839 34.4923C78.839 34.3083 78.991 34.1562 79.175 34.1562C79.364 34.1562 79.515 34.3083 79.515 34.4923C79.515 34.6803 79.363 34.8323 79.175 34.8323ZM78.921 35.1772H79.427V37.4783H78.921V35.1772Z",
    fill: "#260046"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_411_152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 32,
    width: 33,
    height: 7
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M96.714 32.2051H64.127V38.4911H96.714V32.2051Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_411_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.945 37.5238C80.264 37.5238 79.799 36.9768 79.799 36.3278C79.799 35.6788 80.264 35.1318 80.945 35.1318C81.216 35.1318 81.456 35.2238 81.617 35.3898V35.1778H82.123V37.4788H81.617V37.2628C81.456 37.4318 81.217 37.5238 80.945 37.5238ZM81.005 37.0638C81.299 37.0638 81.497 36.9258 81.617 36.7418V35.9088C81.497 35.7298 81.299 35.5908 81.005 35.5908C80.6 35.5908 80.319 35.9218 80.319 36.3268C80.319 36.7328 80.6 37.0638 81.005 37.0638Z",
    fill: "#260046"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_411_152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 32,
    width: 33,
    height: 7
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.714 32.2051H64.127V38.4911H96.714V32.2051Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_411_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.581 35.1769H83.087V35.4209C83.243 35.2279 83.492 35.1309 83.763 35.1309C84.315 35.1309 84.665 35.5079 84.665 36.1019V37.4779H84.159V36.1849C84.159 35.8219 83.975 35.5919 83.653 35.5919C83.382 35.5919 83.184 35.7439 83.087 35.9559V37.4789H82.581V35.1769Z",
    fill: "#260046"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_411_152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 32,
    width: 33,
    height: 7
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.714 32.2051H64.127V38.4911H96.714V32.2051Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_411_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.566 36.6083C85.736 36.8703 86.008 37.0273 86.325 37.0273C86.633 37.0273 86.854 36.8663 86.854 36.6223C86.854 36.3923 86.702 36.2403 86.389 36.1253L86.03 35.9963C85.515 35.8073 85.261 35.5223 85.261 35.0763C85.261 34.5053 85.712 34.1562 86.319 34.1562C86.724 34.1562 87.069 34.3173 87.308 34.6023L86.935 34.9653C86.774 34.7723 86.571 34.6613 86.319 34.6613C86.043 34.6613 85.804 34.8042 85.804 35.0382C85.804 35.2772 85.96 35.3833 86.301 35.5073L86.632 35.6313C87.111 35.8103 87.401 36.1003 87.401 36.5883C87.396 37.1593 86.95 37.5312 86.311 37.5312C85.782 37.5312 85.34 37.2923 85.142 36.9423L85.566 36.6083Z",
    fill: "#260046"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_411_152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 32,
    width: 33,
    height: 7
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.714 32.2051H64.127V38.4911H96.714V32.2051Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_411_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.754 37.4778H89.248V37.2388C89.096 37.4318 88.843 37.5238 88.613 37.5238C88.07 37.5238 87.72 37.1468 87.72 36.5528V35.1768H88.226V36.4698C88.226 36.8328 88.405 37.0628 88.723 37.0628C88.958 37.0628 89.151 36.9158 89.247 36.6998V35.1768H89.753V37.4778H89.754Z",
    fill: "#260046"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_411_152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 32,
    width: 33,
    height: 7
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.714 32.2051H64.127V38.4911H96.714V32.2051Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_411_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.18 35.1769H90.686V35.3889C90.847 35.2229 91.086 35.1309 91.358 35.1309C92.043 35.1309 92.508 35.6779 92.508 36.3269C92.508 36.9759 92.043 37.5229 91.358 37.5229C91.086 37.5229 90.847 37.4309 90.686 37.2609V38.4899H90.18V35.1769ZM91.303 37.0639C91.71 37.0639 91.991 36.7299 91.989 36.3219C91.986 35.8609 91.556 35.5069 91.107 35.6129C90.915 35.6589 90.778 35.7719 90.687 35.9089V36.7419C90.806 36.9259 91.004 37.0639 91.303 37.0639Z",
    fill: "#260046"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_411_152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 32,
    width: 33,
    height: 7
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M96.714 32.2051H64.127V38.4911H96.714V32.2051Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_411_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.393 35.1773H95.899V35.4853C95.986 35.3103 96.221 35.1543 96.479 35.1543C96.576 35.1543 96.659 35.1683 96.714 35.1823L96.64 35.6743C96.594 35.6563 96.52 35.6463 96.442 35.6463C96.24 35.6463 96 35.7613 95.899 36.0003V37.4773H95.393V35.1773Z",
    fill: "#260046"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_411_152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 32,
    width: 33,
    height: 7
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M96.714 32.2051H64.127V38.4911H96.714V32.2051Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_411_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.976 36.1108L70.741 36.0418C70.516 35.9778 70.465 35.8808 70.465 35.7708C70.465 35.6328 70.621 35.5548 70.773 35.5548C70.962 35.5548 71.109 35.6468 71.21 35.7898L71.529 35.4788C71.365 35.2538 71.106 35.1328 70.782 35.1328C70.322 35.1328 69.963 35.3808 69.958 35.7908C69.953 36.1308 70.16 36.3848 70.561 36.4948L70.763 36.5498C71.039 36.6328 71.117 36.7108 71.117 36.8438C71.117 37.0048 70.965 37.0878 70.786 37.0878C70.551 37.0878 70.326 36.9728 70.234 36.7708L69.897 37.0998C70.074 37.3848 70.404 37.5248 70.786 37.5248C71.26 37.5248 71.619 37.2528 71.619 36.8118C71.62 36.4328 71.38 36.2308 70.976 36.1108Z",
    fill: "#260046"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_411_152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 32,
    width: 33,
    height: 7
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M96.714 32.2051H64.127V38.4911H96.714V32.2051Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_411_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.412 37.0106C73.313 37.0526 73.228 37.0686 73.085 37.0686C72.869 37.0686 72.726 36.9626 72.726 36.6776V35.6286H73.412V35.1776H72.726V34.3066H72.22V35.1776H71.77V35.6286H72.221V36.7606C72.221 37.2806 72.575 37.5246 73.022 37.5246C73.171 37.5246 73.307 37.4986 73.413 37.4666V37.0106H73.412Z",
    fill: "#260046"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_411_152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 32,
    width: 33,
    height: 7
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M96.714 32.2051H64.127V38.4911H96.714V32.2051Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_411_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.543 36.7889C94.417 36.9519 94.217 37.0629 93.936 37.0629C93.554 37.0629 93.251 36.8149 93.227 36.4369H95.035C95.04 36.3629 95.04 36.3219 95.04 36.2709C95.04 35.5299 94.534 35.1299 93.931 35.1299C93.224 35.1299 92.719 35.6619 92.73 36.3489C92.742 37.0499 93.351 37.5699 94.05 37.5179C94.437 37.4889 94.735 37.3199 94.928 37.0629L94.543 36.7889ZM93.913 35.5589C94.207 35.5589 94.474 35.7379 94.53 36.0699H93.251C93.32 35.7289 93.619 35.5589 93.913 35.5589Z",
    fill: "#260046"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_411_152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 82,
    y: 32,
    width: 4,
    height: 2
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M82.664 32.5649C82.56 32.5739 82.55 32.7209 82.651 32.7449L84.911 33.2669C85.088 32.8439 85.092 32.4699 84.79 32.3799L82.664 32.5649Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_411_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.113 32.9L83.601 31.127L85.529 32.746L84.042 34.518L82.113 32.9Z",
    fill: "url(#paint0_linear_411_152)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_411_152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 84,
    y: 32,
    width: 3,
    height: 3
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M86.78 32.2051L84.79 32.3791C85.093 32.4711 85.089 32.8431 84.911 33.2661L84.276 34.6271C84.233 34.7191 84.35 34.8021 84.422 34.7311L86.851 32.3611C86.91 32.3031 86.868 32.2051 86.788 32.2051C86.786 32.2051 86.783 32.2051 86.78 32.2051Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_411_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.254 31.9717L87.136 32.2237L86.89 35.0347L84.008 34.7817L84.254 31.9717Z",
    fill: "url(#paint1_linear_411_152)"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M49.989 77.458V77.426C49.723 76.965 49.43 76.54 49.122 76.168V76.182C49.323 76.439 49.648 76.884 49.989 77.458Z",
    fill: "#70331C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M108.447 23.3232H52.934C51.899 23.3232 50.992 23.8602 50.467 24.6682C50.167 25.1292 49.989 25.6772 49.989 26.2682V77.4262V77.4582C50.654 78.5802 51.362 80.1852 51.235 81.8042C51.085 83.7282 50.252 90.2712 49.989 92.3172V103.195C49.989 104.821 51.307 106.14 52.934 106.14H77.937H108.448C109.039 106.14 109.587 105.962 110.048 105.662C110.856 105.137 111.393 104.23 111.393 103.195V26.2682C111.392 24.6422 110.073 23.3232 108.447 23.3232ZM107.479 102.228H53.901V27.2362H74.005V28.7542C74.005 29.4922 74.603 30.0902 75.341 30.0902H86.175C86.837 30.0902 87.374 29.5532 87.374 28.8912V27.2352H107.478V102.228H107.479Z",
    fill: "#260046"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M86.333 94.2031H74.807C74.062 94.2031 73.453 94.8121 73.453 95.5571C73.453 96.3021 74.062 96.9111 74.807 96.9111H86.333C87.078 96.9111 87.687 96.3021 87.687 95.5571C87.687 94.8121 87.078 94.2031 86.333 94.2031Z",
    fill: "#EA4403"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M77.936 106.141C77.953 106.116 77.973 106.089 77.989 106.064H54.468C51.484 106.064 50.009 103.832 50.009 100.848V92.1605C50.291 89.9655 51.089 83.6845 51.235 81.8045C51.36 80.2015 50.668 78.6155 50.009 77.4945V77.4595C49.738 76.9855 49.437 76.5505 49.122 76.1685C49.087 76.1265 49.051 76.0895 49.015 76.0485C48.957 75.9765 48.92 75.9345 48.92 75.9345V75.9415C48 74.9125 46.987 74.3365 46.244 74.5425C44.549 75.0115 44.916 80.5695 43.7 85.2405C42.484 89.9115 41.407 93.1965 39.102 101.969C36.727 111.01 40.555 114.258 39.794 117.39C39.677 117.873 39.363 118.573 38.93 119.397L55.218 126.119C55.46 126.277 55.682 126.439 55.89 126.603C58.354 124.95 62.577 122.552 73.794 110.898C75.332 109.3 76.495 108.025 77.298 107.008C77.422 106.851 77.537 106.701 77.642 106.556C77.748 106.412 77.844 106.275 77.933 106.143C77.935 106.142 77.936 106.141 77.936 106.141Z",
    fill: "#70331C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M55.891 126.602C55.683 126.438 55.46 126.277 55.219 126.118L38.931 119.396L38.51 119.222C36.075 118.217 33.274 119.204 32.006 121.513L22.406 135.493C29.421 142.772 37.798 148.719 47.134 152.933C50.371 145.906 53.698 138.583 56.752 134.565C58.44 132.344 59.177 129.181 55.891 126.602Z",
    fill: "#EA4403"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M132.523 120.316C130.469 118.109 130.803 115.587 118.241 102.462C114.677 98.7392 113.658 97.8042 111.562 97.7952C109.761 97.7882 109.103 98.8492 109.162 99.3312C109.162 99.3312 107.478 97.0602 104.611 98.1692C103.245 98.6972 102.34 100.625 102.34 100.625C102.264 100.55 102.189 100.476 102.112 100.4C100.284 98.6122 98.46 98.4922 96.144 99.6032C94.987 100.158 94.138 102.191 94.138 102.191C91.585 100.007 92.546 101.19 90.308 99.1132C84.79 93.9902 84.08 92.5202 82.4 92.8952C81.101 93.1842 80.77 96.1522 82.364 98.7482C83.738 100.985 84.714 102.551 89.686 107.484C92.897 110.67 95.213 112.742 97.552 115.196C99.468 117.206 103.101 120.603 103.257 122.053C103.413 123.503 95.018 121.146 91.655 121.171C88.292 121.196 85.061 123.783 85.411 125.284C85.761 126.785 90.642 126.663 94.688 127.896C98.735 129.129 101.573 130.19 109.173 132.524C117.006 134.929 119.987 131.694 122.703 132.472C122.952 132.543 123.278 132.69 123.636 132.87C124.775 129.412 127.28 125.086 132.523 120.316Z",
    fill: "#70331C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_411_152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 48,
    width: 36,
    height: 36
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M97.923 48.165H62.923V83.165H97.923V48.165Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_411_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.424 83.168C90.09 83.168 97.925 75.332 97.925 65.667C97.925 56.001 90.09 48.165 80.424 48.165C70.758 48.165 62.923 56.001 62.923 65.667C62.923 75.332 70.758 83.168 80.424 83.168Z",
    fill: "#FBDACD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_411_152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 48,
    width: 36,
    height: 36
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M97.923 48.165H62.923V83.165H97.923V48.165Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_411_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.021 59.9984C86.021 63.0894 83.515 65.3834 80.424 65.3834C77.334 65.3834 74.828 63.0894 74.828 59.9984C74.828 56.9074 77.334 54.4014 80.424 54.4014C83.515 54.4024 86.021 56.9074 86.021 59.9984Z",
    fill: "#260046"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_411_152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 48,
    width: 36,
    height: 36
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M97.923 48.165H62.923V83.165H97.923V48.165Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_411_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.424 65.6123C75.951 65.6123 72.326 69.2383 72.326 73.7103H88.522C88.522 69.2383 84.897 65.6123 80.424 65.6123Z",
    fill: "#EA4403"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_411_152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 48,
    width: 36,
    height: 36
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M97.923 48.165H62.923V83.165H97.923V48.165Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_411_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.619 60.5775C75.619 57.9235 77.771 55.7725 80.424 55.7725C83.079 55.7725 85.23 57.9235 85.23 60.5775C85.23 63.2315 83.079 65.3825 80.424 65.3825C77.77 65.3825 75.619 63.2315 75.619 60.5775Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_411_152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 48,
    width: 36,
    height: 36
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M97.923 48.165H62.923V83.165H97.923V48.165Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_411_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.251 63.5029H78.597V65.8029C78.597 66.8119 79.415 67.6299 80.424 67.6299C81.433 67.6299 82.251 66.8119 82.251 65.8029V63.5029Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_411_152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 48,
    width: 36,
    height: 36
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M97.923 48.165H62.923V83.165H97.923V48.165Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_411_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.245 65.8595C82.246 65.8405 82.251 65.8225 82.251 65.8035V65.0215C81.688 65.2535 81.071 65.3835 80.424 65.3835C79.777 65.3835 79.161 65.2535 78.597 65.0215V65.8035C78.597 65.8235 78.603 65.8405 78.603 65.8595C79.175 66.0575 79.786 66.1685 80.424 66.1685C81.063 66.1685 81.674 66.0565 82.245 65.8595Z",
    fill: "#F5F5F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_411_152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 48,
    width: 36,
    height: 36
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M97.923 48.165H62.923V83.165H97.923V48.165Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_411_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.37 59.6681C85.37 60.0491 85.331 60.4161 85.251 60.7701C84.202 60.4731 83.103 59.0641 83.011 57.9701C82.061 59.5051 79.016 61.0681 77.078 61.0681C76.487 61.0681 75.918 60.9711 75.389 60.7971C75.306 60.4341 75.262 60.0571 75.262 59.6681C75.262 58.3291 75.783 57.1131 76.632 56.2071C77.656 55.3711 78.955 54.8721 80.382 54.8721C81.559 54.8721 82.652 55.2131 83.576 55.8041C84.674 56.7321 85.37 58.1191 85.37 59.6681Z",
    fill: "#260046"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_411_152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 48,
    width: 36,
    height: 36
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M97.923 48.165H62.923V83.165H97.923V48.165Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_411_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.37 59.6683C85.37 60.0493 85.331 60.4163 85.251 60.7703C84.202 60.4733 83.103 59.0643 83.011 57.9703C82.061 59.5053 79.016 61.0683 77.078 61.0683C76.487 61.0683 75.918 60.9713 75.389 60.7973C75.306 60.4343 75.262 60.0573 75.262 59.6683C75.262 58.3293 75.783 57.1133 76.632 56.2073C77.555 55.2263 78.863 54.6143 80.316 54.6143C81.559 54.6143 82.696 55.0603 83.575 55.8043C84.674 56.7323 85.37 58.1193 85.37 59.6683Z",
    fill: "#260046"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M68.309 64.155C72.725 64.155 76.304 60.576 76.304 56.16C76.304 51.744 72.725 48.165 68.309 48.165C63.893 48.165 60.314 51.744 60.314 56.16C60.314 60.576 63.893 64.155 68.309 64.155Z",
    fill: "#EA4403"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M67.626 58.4662C67.518 58.4662 67.411 58.4252 67.328 58.3432L65.159 56.1742C64.995 56.0102 64.995 55.7432 65.159 55.5792C65.323 55.4152 65.589 55.4152 65.754 55.5792L67.637 57.4622L71.875 53.5312C72.045 53.3732 72.311 53.3832 72.469 53.5532C72.627 53.7232 72.617 53.9902 72.447 54.1482L67.912 58.3542C67.831 58.4282 67.728 58.4662 67.626 58.4662Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M148.672 121.042L141.459 116.902C139.905 115.98 137.941 116.085 136.503 117.179C135.782 117.728 135.107 118.037 134.457 118.578C134.327 118.687 134.19 118.796 134.062 118.904C128.041 124.006 125.268 128.21 123.666 132.768C123.55 133.097 123.442 133.411 123.343 133.724C122.503 136.385 122.421 138.536 122.534 139.956C122.623 141.078 123.181 142.107 124.08 142.785L125.236 145.977C134.726 139.457 142.739 130.947 148.672 121.042Z",
    fill: "#EA4403"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_411_152",
    x1: 83.5539,
    y1: 33.3884,
    x2: 84.643,
    y2: 32.0905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E14403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1155,
    stopColor: "#E14403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2627,
    stopColor: "#E24A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4568,
    stopColor: "#E35A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#E57203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7917,
    stopColor: "#E88402"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFA500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_411_152",
    x1: 84.5624,
    y1: 33.5507,
    x2: 86.9479,
    y2: 33.7594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E14403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1155,
    stopColor: "#E14403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2352,
    stopColor: "#E24A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393,
    stopColor: "#E35A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E57203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6608,
    stopColor: "#EA8402"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8814,
    stopColor: "#F7B201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_411_152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLaptopTick);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/laptop-tick.364053b59d408113429db51878311f01.svg";